import CoreApi from '@/api/CoreApi';
import type { User } from '@/models/User';
import type { Role } from '@/models/Roles';

export async function loadAdminUsers(): Promise<User[]> {
  try {
    const response = await CoreApi.axiosClient.get('/admin/users');
    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error('Failed to load admin users');
  }
}

export async function patchUser(user: User): Promise<void> {
  try {
    await CoreApi.axiosClient.patch('/admin/users', user);
  } catch (error) {
    console.error(error);
    throw new Error('Failed to patch user');
  }
}

export async function loadUserRoles(): Promise<Role[]> {
  try {
    const response = await CoreApi.axiosClient.get('/admin/roles');
    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error('Failed to patch user');
  }
}
